import React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import { theme } from 'lib/style';
import RankIcon from 'lib/images/RankIcon';

const Medal = styled.div`
  width: 36px;
  height: 36px;
  position: relative;
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Number = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  font-weight: 800;
  font-size: 16px;
  line-height: 1;
  color: ${theme.palette.white};
`;

type Props = {
  rank: number;
};

export const Rank = ({ rank }: Props) => {
  const showIcon = rank <= 3;
  const themes = useTheme();
  return (
    <>
      {showIcon && (
        <Medal>
          <IconWrapper>
            <RankIcon color={themes.colors.primaryColor} />
          </IconWrapper>
          <Number>{rank}</Number>
        </Medal>
      )}
      {!showIcon && rank}
    </>
  );
};
